export const PMI_ROUTES = [
    "bba-in-project-management",
    "bba-in-project-management-v1",
    "bca-in-project-management",
    "bca-in-project-management-v1",
    "mca-in-project-management",
    "mca-in-project-management-v1",
    "mba-in-project-management",
    "mba-in-project-management-v1"
]